import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
import logoImg from './assets/titlescreenlogo.png';
import './main-page.css';
import { Link } from 'react-router-dom';

function MainPage(props) {
    const { user, currentEvent } = props;
    return (
        <Container className="text-center py-5">
            <h4>Добро пожаловать, {user ? (user.name ? user.name : '??????') : 'Гость'}!</h4>
            <div className="main-logo-bg">
                <img src={logoImg} alt="Logo" />
                <div className="main-logo-text">{(currentEvent && currentEvent.title) || 'Феникс'}</div>
            </div>
            <h5>
                Смотри <Link to="/program">Программу</Link> или
                <br /> <Link to="/new-request">Создавай</Link> / <Link to="/requests">Смотри свои заявки</Link>
            </h5>
        </Container>
    );
}

function mapStateToProps(state) {
    const {
        auth: { user },
        events: { currentEvent },
    } = state;
    return { user, currentEvent };
}

export default connect(mapStateToProps)(MainPage);
